import { createSelector } from 'reselect';

export const userInvoiceSelector = state => state.invoices;

export const invoicesSelector = createSelector(
  userInvoiceSelector,
  invoices => invoices || []
);
